import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import vietnam from "./vietnam.json"
import english from "./english.json"


const resources = {
    eng: {
        translation: english,
    },
    vie: {
        translation: vietnam,
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "vie",
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;